import loadable from 'helper/loadable'

const Dashboard = loadable(() => import('view/page/dashboard'))
const Explorer = loadable(() => import('view/page/explorer'))
const Map = loadable(() => import('view/page/map'))
const Notes = loadable(() => import('view/page/notes'))
const Report = loadable(() => import('view/page/report'))
const Login = loadable(() => import('view/page/login'))
const LoggedInRoutes = loadable(() => import('./logged-in-routes'))
export { Dashboard, Explorer, Map, Notes, Report, Login, LoggedInRoutes }
